export const versionNames = `
  fft60
`.trim().split(/\s+/);
